const toTopBtn = document.querySelector('.js-to-top-btn');
if (toTopBtn) {
    toTopBtn.addEventListener('click', pageScrollTop);
    handlePageScroll();
    window.addEventListener('scroll', handlePageScroll);
}

function pageScrollTop() {
    window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
    });
    toTopBtn.classList.remove('hidden');
}

function handlePageScroll() {
    let windowScroll = window.pageYOffset;
    let windowHeight = window.outerHeight;

    if (windowScroll > windowHeight / 2) toTopBtn.classList.remove('hidden');
    else toTopBtn.classList.add('hidden');
}